module.exports = __webpack_public_path__ + "media/images/products/cards/operação_fenix-5330bff367608831029bd2c497ac3199.png";